<template>
  <div class='panel bgPanel mt1x cb'>
    <loading v-show="isLoading"></loading>
    <div class="title title-bg">
      <span :title="getLanguageStr('plant458', '子系统信息')">{{getLanguageStr('plant458', '子系统信息')}}</span>
    </div>
    <div class="w100pct mt1x clearfix w33pct_E fL_E pl1x_E mb2x_E flexBox flex-c">
      <div class='flexBox flex-r w100pct'>
        <div class='flex-1' style='text-align:left'>{{getLanguageStr('word1719','子系统名称')}}:</div>
        <div class='flex-1 pr1x' style='text-align:right'>{{basicInfoSys.name?basicInfoSys.name:'--'}}</div>
      </div>
      <div class='flexBox flex-r w100pct'>
        <div class='flex-1' style='text-align:left'>{{getLanguageStr('plant136','子系统类型')}}:</div>
        <div class='flex-1 pr1x' style='text-align:right'>{{basicInfoSys.functionType?getTypeText(basicInfoSys.functionType,'stationtype'):'--'}}</div>
      </div>
      <div class='flexBox flex-r w100pct' v-if='functionType==="GENERATION"'>
        <div class='flex-1' style='text-align:left'>{{getLanguageStr('word727', '装机容量')}}:</div>
        <div class='flex-1 pr1x' style='text-align:right'>{{basicInfoSys.installedCapacity?basicInfoSys.installedCapacity:'--'}}kWp</div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapMutations} from 'vuex'
import {getLanguageStr} from '@/util/language.js'
import * as equipmentApi from '@/api/maintain/plant/list'
import Loading from '@/components/common/ui/Loading'
import * as lib from '@/util/lib.js'
export default {
  name: 'childsysdetail',
  components: {Loading},
  data () {
    return {
      stage,
      isLoading: false,
      basicInfoSys: {},
      metering: []
    }
  },
  props:{
    functionType:{
      type: String,
      default:''
    },
    roleCode: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    getLanguageStr,
    getTypeText: lib.getTypeText,
    	clone (arr) {
      return _.cloneDeep(arr)
    },
    ...mapMutations({
      SetinstalledCapacity: 'fix/SetinstalledCapacity'
    }),
    doPermissions: lib.doPermissions,
    // 获取详情-电站信息
    _getBasicInfo (id) {
      this.isLoading = true
      let rc
      if (this.roleCode && this.roleCode.length === 0) {
        rc = null
      } else {
        rc = this.roleCode
      }
      if (!this.doPermissions('A/B/A7', {targetCode: 'A3', codeList: this.clone(rc)})) {
        this.basicInfoSys.installedCapacity = null
        this.basicInfoSys.name = null
        this.basicInfoSys.functionType = null
        this.isLoading = false
        return
      }
      equipmentApi.getChildSys(id).then(response => {
        this.isLoading = false
        this.basicInfoSys = response
        this.SetinstalledCapacity(this.basicInfoSys.installedCapacity)
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
        this.isLoading = false
      })
    }
  },
  mounted () {
    // console.log(this.stationInfo, this.stationInfoSys)
  }
}
</script>
<style lang="scss" scoped>
  .flexBox{
    display: flex;
  }
  .flex-r{
    flex-direction: row;
  }
  .flex-c{
    flex-direction: column;
  }
  .flex-1{
    flex: 1
  }
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/ChildSysDetail.vue